import React from 'react';
import PropTypes from 'prop-types';
import withLocalization from '../higherOrderComponents/withLocalization';
import Icon from './Icon';

const Loader = ({ hasLoaded = false, translate, children = null, loadingText }) => {
  const wrapperClasses = ['loader-wrap'];
  const contentClasses = ['content-to-load'];

  if (hasLoaded) {
    wrapperClasses.push('has-loaded');
  }

  else {
    contentClasses.push('is-loading');
  }

  return (
    <div className={wrapperClasses.join(' ')}>
      <article className='loader'>
        <Icon iconName='circle' className='loader-image' />
        <p>{loadingText || translate('text-loading')}</p>
      </article>

      <div className={contentClasses.join(' ')}>
        {children}
      </div>
    </div>
  );
};

Loader.propTypes = {
  hasLoaded: PropTypes.bool.isRequired,
  loadingText: PropTypes.string
};

export default withLocalization(Loader, 'elements/loader');